import { useCallback } from 'react'
import { KEY_CODES } from '../../../../constants/utility'
import { ListItem } from '../ListItem'
import { useDropdownContext } from './DropdownContext'

export interface DropdownItemProps {
  children: React.ReactNode
  isActive?: boolean
  lastItem?: boolean
  onBlur?: () => void
  onClick?: (e) => void
  onFocus?: () => void
}

export const DropdownItem = ({
  children,
  isActive,
  lastItem,
  onBlur,
  onClick,
  onFocus,
  ...restProps
}: DropdownItemProps) => {
  const { setIsOpen } = useDropdownContext()

  const handleOnClick = useCallback(
    e => {
      e.stopPropagation()
      onClick?.(e)
      setIsOpen(false)
    },
    [onClick, setIsOpen]
  )

  const handleKeyDown = useCallback(
    e => {
      e.stopPropagation()

      if (e.keyCode === KEY_CODES.enter) {
        onClick?.(e)
        setIsOpen(false)
      }
    },
    [onClick, setIsOpen]
  )

  const handleOnBlur = useCallback(() => {
    if (lastItem) {
      setIsOpen(false)
    }

    onBlur?.()
  }, [onBlur, setIsOpen, lastItem])

  return (
    <ListItem
      isActive={isActive}
      onBlur={handleOnBlur}
      onFocus={onFocus}
      onClick={handleOnClick}
      onKeyDown={handleKeyDown}
      {...restProps}
    >
      {children}
    </ListItem>
  )
}
